var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-grid"},[_c('div',{staticClass:"b-brick",style:({
      gridArea: (_vm.startColumn + " / " + _vm.startRow + " / span 2 / span 2"),
    }),attrs:{"data-active":_vm.isActive}})])}
var staticRenderFns = []

export { render, staticRenderFns }